import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { NavProfile } from './NavProfile';
import { NavHelp } from './NavHelp';
import { useAppUserPathPrefix } from 'App/components/utils/providers/AppUserProvider';
import { NavReminders } from './NavReminders';

export const NavRight: React.FC = () => {
  const userPrefix = useAppUserPathPrefix();

  return (
    <ul className="navbar-nav ml-auto">
      <li>
        <a className="align-vertical-middle" href={ `${userPrefix}/tasks` }>
          <i className="material-icons material-icons-outlined align-vertical-middle">assignment</i>
        </a>
      </li>
      <li>
        <NavHelp />
      </li>
      <li>
        <NavReminders />
      </li>
      <li>
        <Dropdown className="drp-user">
          <NavProfile />
        </Dropdown>
      </li>
    </ul>
  );
};
